import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_openBlock(), _createBlock(_component_async_btn, _mergeProps({
    task: _ctx.task,
    icon: "fa fa-refresh",
    label: "Regenerate",
    rounded: "",
    flat: ""
  }, _ctx.$attrs, { onClick: _ctx.regenerate }), null, 16, ["task", "onClick"]))
}